<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 18:23:36
 * @LastEditors: error: git config user.email & please set dead value or install git
 * @LastEditTime: 2023-05-04 18:19:32
 * @Description: grid布局，一个grid代表一行<Row>
 -->
<template>
    <a-form-item
        v-if="!options.hidden"
        :label="label"
        :class="[{ 'ant-form-item-disabled': disabled }]"
        class="form-item-table"
    >
        <div class="form-item-table-header no-print">
            <div class="form-item-table-action" v-if="!disabled">
                <a-button-group>
                    <a-button
                        size="small"
                        type="primary"
                        @click="addRow"
                        icon="plus"
                        >{{ t("wg.table.add") }}</a-button
                    >
                    <a-popconfirm
                        v-if="layout === 'table'"
                        :title="t('wg.table.confirm')"
                        @confirm="delRow"
                    >
                        <a-button size="small" icon="minus">{{
                            t("wg.table.batchDel")
                        }}</a-button>
                    </a-popconfirm>
                    <template v-if="options.importSupport">
                        <a-upload
                            name="file"
                            action=""
                            :fileList="[]"
                            :before-upload="beforeUpload"
                            @change="handleImport"
                        >
                            <a-button
                                size="small"
                                type="primary"
                                :loading="importLoading"
                                icon="import"
                                >{{ t("wg.table.import") }}</a-button
                            >
                        </a-upload>
                        <a-button
                            size="small"
                            type="primary"
                            @click="handleUpload"
                            :loading="uploadLoading"
                            icon="upload"
                            >{{ t("wg.table.upload") }}</a-button
                        >
                    </template>
                </a-button-group>
                <!-- 操作区域额外slot -->
                <!-- <slot :name="widget.model"
          :wg="widget.model"></slot> -->
            </div>

            <div style="float: right">
                <switch-layout
                    :disabled="disabled"
                    @change="handleTableLayoutChange"
                ></switch-layout>
            </div>
        </div>
        <widgetItem
            :fieldName="widget.model"
            :data-model="widget.model"
            :lang="lang"
            ref="subTable"
            :layout="layout"
            :widget="widget"
            :disabled="disabled"
            @change="handleChange"
            v-decorator="decorator"
            @noticeParent="handleNoticeParent"
        >
        </widgetItem>

        <div>
            <slot
                :name="widget.model + '_footer'"
                :wg="widget.model + '_footer'"
            ></slot>
        </div>
    </a-form-item>
</template>

<script>
import { t } from "../../locale";
import props from "../../lib/props";
import widgetItem from "./table";
import switchLayout from "./switch-layout";
// import baseMixin from '../../lib/baseMixin';

export default {
    components: {
        widgetItem,
        switchLayout,
    },
    name: "wgTable",
    mixins: [props],
    data() {
        return {
            layout: "table",
            importLoading: false,
            uploadLoading: false,
        };
    },
    methods: {
        t(...args) {
            return t.apply(this, args);
        },
        /**
         * rows 是辅助子表数据
         */
        handleChange(rows) {
            // 先触发辅助子表内部事件，使页面执行渲染，
            // 将数据抛给上一层，主要是被子表格服务
            this.$emit("change", rows);
        },
        // disabled属性变更
        handleDisabled(val) {
            this.disabled = val;
        },
        addRow() {
            this.$refs.subTable.addRow();
        },
        delRow() {
            this.$refs.subTable.delRow();
        },
        handleTableLayoutChange(val) {
            this.layout = val;
            this.$refs.subTable.layoutChange(val);
        },
        handleUpload() {
            const param = this.widget;
            this.uploadLoading = true;
            this.formContext.remote
                .exportChild(param)
                .then((data) => {
                    const blob = new Blob([data], {
                        type: "application/vnd.ms-excel",
                    });
                    const fileName = "表单内容模版.xlsx";
                    this.exportFile({ blob, fileName });
                })
                .catch(() => {
                    this.$message.error("模版下载失败");
                })
                .finally(() => {
                    this.uploadLoading = false;
                });
        },
        exportFile({ fileName, blob }) {
            if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
            }
        },
        beforeUpload(file) {
            this.fileList = [file];
            return false;
        },
        handleImport() {
            this.importLoading = true;
            const targetFile = this.fileList[0];
            const formData = new FormData();
            formData.append("content", targetFile);
            this.formContext.remote
                .uploadFile(formData, targetFile.name)
                .then((res) => {
                    if (res.success) {
                        const { viewUrl: downloadUrl } = res.content || {};
                        const param = {
                            file: {
                                downloadUrl,
                            },
                            table: this.widget,
                        };
                        return this.formContext.remote.analysisExcel(param);
                    }
                    return Promise.reject(new Error(res.message));
                })
                .then((res) => {
                    const { data } = res;
                    this.importLoading = false;
                    this.$message.success("Success!");
                    const dataList = data.map((item) => {
                        const map = new Map(
                            item.map((it) => [it.key, it.value])
                        );
                        return Object.fromEntries(map);
                    });
                    this.$refs.subTable.updateImportData(dataList);
                })
                .catch((error) => {
                    this.$message.error(error.message);
                    this.importLoading = false;
                });
        },
    },
    // end method
};
</script>
<style lang="less">
.ant-upload-list,
.ant-upload-list-text {
    display: inline-block;
}
</style>
